import React, { useState, useEffect } from 'react';
import { useCMS } from '../context/CMSContext';

const getSocialIcon = (name) => {
  switch (name) {
    case 'Facebook':
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{ display: 'block' }}>
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
        </svg>
      );
    case 'Instagram':
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'block' }}>
          <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
          <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
          <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
        </svg>
      );
    case 'WhatsApp':
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{ display: 'block' }}>
          <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 12.008.01c3.202.001 6.212 1.246 8.477 3.514 2.266 2.268 3.507 5.28 3.505 8.484-.004 6.657-5.34 11.997-11.953 11.997-2.005-.001-3.973-.502-5.724-1.455L0 24zm6.59-4.846c1.6.95 3.188 1.449 4.825 1.451 5.436 0 9.86-4.42 9.864-9.864.002-2.637-1.019-5.117-2.875-6.973-1.857-1.857-4.335-2.88-6.97-2.881-5.437 0-9.866 4.422-9.87 9.865-.001 1.748.472 3.453 1.371 4.965l-.995 3.633 3.73-.977zm11.517-5.637c-.301-.15-1.782-.88-2.056-.98-.275-.1-.475-.15-.675.15-.2.3-.775.98-.95 1.18-.175.2-.35.225-.65.075-.3-.15-1.265-.467-2.41-1.485-.89-.795-1.49-1.77-1.665-2.07-.175-.3-.019-.462.13-.611.135-.135.3-.35.45-.525.15-.175.2-.3.3-.5.1-.2.05-.375-.025-.525-.075-.15-.675-1.625-.925-2.225-.244-.589-.493-.51-.675-.52-.175-.01-.375-.01-.575-.01-.2 0-.525.075-.8 1.05-.275 1.05-.8 2.65-.875 2.8-.075.15-.15.3-.3 0-.6-.3-1.875-.725-2.675-1.525-.775-.775-1.125-1.775-1.25-2.025-.125-.25-.075-.375.05-.5.125-.125.25-.275.375-.425.125-.15.15-.25.225-.425.075-.175.037-.325-.012-.425-.05-.1-.475-1.15-.65-1.575-.175-.421-.375-.363-.525-.371-.15-.009-.325-.01-.5-.01-.175 0-.45.066-.688.329-.237.262-.912.891-.912 2.171s.938 2.512 1.062 2.688c.125.175 1.845 2.818 4.47 3.962.624.272 1.11.435 1.49.556.628.2 1.2.172 1.654.105.506-.075 1.782-.728 2.031-1.432.25-.704.25-1.307.175-1.432-.075-.125-.275-.2-.575-.35z" />
        </svg>
      );
    case 'LinkedIn':
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{ display: 'block' }}>
          <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
        </svg>
      );
    default:
      return name;
  }
};

export default function Footer() {
  const [showBackToTop, setShowBackToTop] = useState(false);
  const currentYear = new Date().getFullYear();

  const { globalData, servicesData } = useCMS();
  const { logo, navLinks, headerCta } = globalData;
  const { description, socials, contact, ctaLabel, copyright, links } = globalData.footer;
  const { servicesGrid } = servicesData;

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleScrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <footer>
        <div className="wrap">
          <div className="footer-grid">
            <div>
              <a href={logo.link} className="logo" style={{ marginBottom: '18px' }}>
                {logo.useSvg ? (
                  <img src={logo.src} alt={logo.alt} width="160" height="32" loading="lazy" style={{ height: '32px', width: 'auto', aspectRatio: '160 / 32', display: 'block' }} />
                ) : (
                  <>
                    <span className="mark"></span>{logo.text}<span className="b">{logo.boldText}</span>
                  </>
                )}
              </a>
              <p style={{ maxWidth: '320px', fontSize: '14px' }}>
                {description}
              </p>
              <div className="social-row" style={{ marginTop: '22px' }}>
                {socials.map((soc) => (
                  <a target='_blank' rel='noopener noreferrer' key={soc.name} href={soc.url} aria-label={soc.name}>
                    {getSocialIcon(soc.name)}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h3 className="footer-heading">Services</h3>
              <ul>
                {servicesGrid.map((s) => (
                  <li key={s.num}><a href={s.link}>{s.title.replace(" Services", "").replace(" Agency Services", "")}</a></li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="footer-heading">Company</h3>
              <ul>
                {navLinks.slice(1).map((link) => (
                  <li key={link.key}><a href={link.href}>{link.label === "Services" ? "All Services" : link.label === "About" ? "About Us" : link.label}</a></li>
                ))}
                {links.map((link) => (
                  <li key={link.label}><a href={link.href}>{link.label}</a></li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="footer-heading">Get In Touch</h3>
              <ul>
                <li><a href={`mailto:${contact.email}`}>{contact.email}</a></li>
                <li><a href={`tel:${contact.phone.replace(/\s+/g, '')}`}>{contact.phone}</a></li>
                <li><a href={contact.locationLink}>{contact.location}</a></li>
              </ul>
              <a href={headerCta.href} className="btn btn-ghost btn-sm" style={{ marginTop: '18px' }}>
                {ctaLabel}
              </a>
            </div>
          </div>
          <div className="footer-bottom">
            <p>© {currentYear} {copyright}</p>
            <p>
              {links.map((link, idx) => (
                <React.Fragment key={idx}>
                  {idx > 0 && <React.Fragment> &nbsp;·&nbsp; </React.Fragment>}
                  <a href={link.href}>{link.label}</a>
                </React.Fragment>
              ))}
            </p>
          </div>
        </div>
      </footer>
      <a
        href="#top"
        className={`back-to-top ${showBackToTop ? 'show' : ''}`}
        id="backToTop"
        aria-label="Back to top"
        onClick={handleScrollToTop}
      >
        ↑
      </a>
    </>
  );
}
